import React from 'react'
import { Button, Card, Flex, PasswordInput, Stack } from '@mantine/core'
import { useFormik } from 'formik'
import * as yup from 'yup'
import { useActions } from 'src/state'
import { useSearchParams } from 'react-router-dom'

const validationSchema = yup.object({
    password: yup.string().required('Password is required').min(8, 'Password must be at least 8 characters').matches(/[a-zA-Z]/, 'Password must contain at least one letter'),
    verify_password: yup.string().required('Please confirm your password').oneOf([yup.ref('password')], 'Passwords do not match'),
})

const PasswordResetForm: React.FC = () => {

    const [searchParams] = useSearchParams()
    const resetPasswordAction = useActions().resetPasswordAction

    const formik = useFormik({
        initialValues: {
            password: '',
            verify_password: '',
        },
        validationSchema,
        validateOnBlur: true,
        validateOnChange: true,
        onSubmit: async ({ password }) => {
            const token = searchParams.get('token')
            if (token) {
                const success = await resetPasswordAction({ password, token })
                if (success) {
                    window.location.assign('/')
                }
            }
        },
    })

    return (
        <Flex
            justify="center"
            align="center"
        >
            <Card
                withBorder
                shadow="sm"
                p="md"
                w={400}
            >
                <form onSubmit={formik.handleSubmit}>
                    <Stack gap="sm">

                        <PasswordInput
                            label="Password"
                            name="password"
                            value={formik.values.password}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.password && formik.errors.password}
                        />

                        <PasswordInput
                            label="Confirm Password"
                            name="verify_password"
                            value={formik.values.verify_password}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.verify_password && formik.errors.verify_password}
                        />

                        <Button
                            type="submit"
                            fullWidth
                            loading={formik.isSubmitting}
                            disabled={!formik.isValid || formik.isSubmitting}
                            mt="md"
                        >
                            Set New Password
                        </Button>

                    </Stack>
                </form>
            </Card>
        </Flex>
    )
}

export default PasswordResetForm
